
// Set Genesys Cloud objects

class GenesysSDKPhoneControls {

    // Set Genesys Cloud settings
    constructor(environmentSettings, clientSDKObjInstance) {
        this.clientSDKObjInstance = clientSDKObjInstance;
        this.initializeGenesys(environmentSettings.clientId, environmentSettings.redirectUri, environmentSettings.currenUser, environmentSettings.webSocket);
    }

    initializeGenesys(clientId, redirectUri, currentUser, webSocket) {
        this.clientSDKObjInstance.genesysSDKClientInstance.loginImplicitGrant(clientId, redirectUri)
            .then(() => {
                console.log('Logged in');
                // Get authenticated user's info
                return this.clientSDKObjInstance.usersApi.getUsersMe();
            })
            .then((userMe) => {
                console.log('userMe: ', userMe);
                this.clientSDKObjInstance.currentUser = userMe;
                this.clientSDKObjInstance.searchAgentForUserMe(userMe?.email);
            })
            .catch((err) => console.error(err));
    }
}

// 1. { clientId: this.clientId, redirectUri: this.redirectUri, webSocket: this.webSocket, currentUser: this.currentUser }, 
// 2. this
class OpenFrameAPI {
    openFrameAPIClient;
    config = {height: 500,width: 300}
    componentIns
    statusIds = {
        'Available': '6a3af858-942f-489d-9700-5f9bcdcdae9b',
        'Break': '227b37e2-f1d0-4dd0-8f50-badd7cf6d158',
        'Lunch': '3fd96123-badb-4f69-bc03-1b1ccc6d8014',
        'QA Activities': 'd2390a99-8546-bad9-8f0a-219548e8aeb0'
    }

    constructor(componentIns) {
        this.openFrameAPIClient = SNC?.OpenFrame;
        this.initializeOpenFrameAPI();
        componentIns.openFrameAPIClient = this.openFrameAPIClient;
        this.componentIns = componentIns
    }
    
    initializeOpenFrameAPI() {
        this.openFrameAPIClient.init(this.config, this.initSuccess, this.initFailure);
        
    }
    
    /**
     * register for communication event from TopFrame
     * @param {*} snConfig 
     */
    initSuccess = (snConfig) => {
        console.log("openframe configuration", snConfig);
        this.initializeOpenFrameListener();
    }
       
    initFailure = (error) => {console.log("OpenFrame init failed...", error);}
    
    handleCommunicationEvent = (context)=> {
            console.log("Communication from Topframe in OpenFrameAPI", context);
        }

    manageUserStatus = (context) =>{
        console.log("Status Change Detected", context);
        this.openFrameAPIClient.getAWAAgentPresence((data) => { console.log("success: " + JSON.stringify(data));}, () => {console.log("failure: " + JSON.stringify(data));})
        // context?.result?.presence ? this.componentIns.updateUserStatus(this.statusIds[context.result.presence.name]): '';
    }

    initializeOpenFrameListener(){
        this.openFrameAPIClient.subscribe(this.openFrameAPIClient.EVENTS.OPENFRAME_AWA_AGENT_PRESENCE, this.manageUserStatus);
        this.openFrameAPIClient.subscribe(this.openFrameAPIClient.EVENTS.COMMUNICATION_EVENT,this.handleCommunicationEvent);
    }
}
  
    
    